// extracted by mini-css-extract-plugin
module.exports = {"withBackArrow":"FooterPanel_withBackArrow__CNtwA"};